module.exports = __webpack_public_path__ + "img/Burri_Portrait.84450d78.jpg";